<div class="qr flex flex-col items-center">
  <div class="float__icon x_shape" inlineSVG="jumbotron/xshape.svg"></div>
  <div class="float__icon square_shape" inlineSVG="jumbotron/square.svg"></div>
  <div class="qr__container">
    <p translate="QR Code Generator"></p>
    <!-- <img src="/assets/media/svg/features/qrcode.svg" alt="qr__code" width="257" height="257" /> -->
    <span inlineSVG="features/qrcode.svg" style="    width: 257px;
    height: 257px;"></span>
  </div>
  <app-statistics-card class="visitors__card" cardTitle="Total Visitors" total="12,489"
    icon="features/profile.svg"></app-statistics-card>
  <app-statistics-card class="scans__card" cardTitle="Total Scans" total="12,489"
    icon="features/scan.svg"></app-statistics-card>
  <div class="link__copy reverse__input-icon flex">
    <p class="flex-1">pst5.com/qr_IJnPnD</p>
    <div class="copy__icon" inlineSVG="jumbotron/document_copy.svg"></div>
  </div>
</div>